import {
  DateValueLineGraph,
  DateValueLineGraphLoadingLarge,
  DateValueLineGraphLoadingSmall,
} from '#/atoms/graphs/date-value-line-graph';
import {LandGraphData, useLandGraphData} from '#/components/graphs/use-land-graph-data';
import {GraphRange, Land} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';

export const LandMarketPriceGraph: FunctionComponent<{
  land: Land;
  graphRange: GraphRange;
  size: 'small' | 'large';
}> = ({land, graphRange, size}) => {
  const {data = [], isLoading} = useLandGraphData(graphRange, land.tokenSymbol);

  return (
    <div className={`${size === 'small' ? 'w-28' : 'w-40'} h-12`}>
      {isLoading ? (
        graphRange === 'day' ? (
          <DateValueLineGraphLoadingSmall />
        ) : (
          <DateValueLineGraphLoadingLarge />
        )
      ) : (
        <DateValueLineGraph<LandGraphData> data={data} isLoading={false} yDataKey='marketPrice' />
      )}
    </div>
  );
};
